import { render } from "./PBlocked.vue?vue&type=template&id=a9eff75e"
import script from "./PBlocked.vue?vue&type=script&lang=js"
export * from "./PBlocked.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__